
import { getCdnUrl } from '~/utils/mediaUtils'

const VALID_DETAILS = ['desc', 'list', 'card', 'thumb', 'main', 'sub', 'banner', 'profile', 'badge', 'capture', 'review', 'thumbnail']
const VALID_SIZES = ['60', '300', '850', '1280', '300x400', '100x100', 'original']

export default {
  name: 'DaisoResizedImage',
  inheritAttrs: false,
  props: {
    src: {
      type: [String, null],
      default: null
    },
    detail: {
      type: String,
      default: 'banner',
      validator: (value) => {
        if (!VALID_DETAILS.includes(value)) {
          console.warn(`[DaisoResizedImage] Invalid detail: ${value}. Must be one of: ${VALID_DETAILS.join(', ')}`)
          return false
        }
        return true
      }
    },
    size: {
      type: String,
      default: '300',
      validator: (value) => {
        if (!VALID_SIZES.includes(value)) {
          console.warn(`[DaisoResizedImage] Invalid size: ${value}. Must be one of: ${VALID_SIZES.join(', ')}`)
          return false
        }
        return true
      }
    },
    quality: {
      type: Number,
      default: null
    },
    autorotate: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: () => ({})
    },
    alt: {
      type: String,
      default: ''
    },
    imageClass: {
      type: String,
      default: ''
    },
    priority: {
      type: Boolean,
      default: false
    },
    loading: {
      type: String,
      default: null
    },
    fetchpriority: {
      type: String,
      default: null
    },
    decoding: {
      type: String,
      default: 'async'
    },
    fallbackEnabled: {
      type: Boolean,
      default: true
    },
    useSwiperLazy: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isErrorHandled: false,
      noImagePath: '/images/tempLy/noimage.png',
      currentSrc: null
    }
  },
  computed: {
    nativeListeners () {
      const listeners = { ...this.$listeners }
      delete listeners.load
      delete listeners.error
      return listeners
    },
    effectiveLoading () {
      return this.loading || (this.priority ? 'eager' : 'lazy')
    },
    effectiveFetchpriority () {
      return this.fetchpriority || (this.priority ? 'high' : 'auto')
    },
    defaultSrc () {
      return this.processedUrl(getCdnUrl(this.buildLambdaUrl()))
    },
    fallbackSrc () {
      return this.error || this.noImagePath
    }
  },
  watch: {
    src: {
      immediate: true,
      handler () {
        this.isErrorHandled = false
        this.currentSrc = this.defaultSrc
      }
    }
  },
  beforeDestroy () {
    // 로딩 중인(미완료) 이미지만 src를 비워 네트워크 요청을 취소한다.
    // 이미 로드 완료된 이미지는 그대로 둔다 - 떠나는 페이지는 어차피 곧 통째로 제거되므로
    // 여기서 지우면 그 순간 화면에 깨진 이미지 아이콘이 잠깐 노출된다(DEV-11335).
    const el = this.$el
    if (el && el.tagName === 'IMG' && !el.complete) {
      el.removeAttribute('src')
      el.removeAttribute('srcset')
    }
  },
  methods: {
    buildLambdaUrl () {
      if (!this.src) {
        return ''
      }

      let cleanSrc = this.src

      // 이미 CDN URL인 경우 경로만 추출
      if (cleanSrc.startsWith('http://') || cleanSrc.startsWith('https://')) {
        try {
          const url = new URL(cleanSrc)
          cleanSrc = url.pathname
        } catch (e) {
          console.warn('[DaisoResizedImage] Invalid URL:', cleanSrc)
          return ''
        }
      }

      // dims, xcdr 경로 제거
      cleanSrc = cleanSrc.replace(/\/(dims|xcdr)\/.*$/, '')

      // 이미 Lambda 이미지 URL이면 중복 리사이징하지 않는다.
      if (cleanSrc.startsWith('/file/resize/')) {
        return cleanSrc
      }

      // /file/로 시작하지 않으면 static 이미지로 간주 (Lambda 거치지 않음)
      if (!cleanSrc.startsWith('/file/')) {
        return cleanSrc
      }

      const pathParts = cleanSrc.replace(/^\/file\//, '').split('/')

      if (pathParts.length < 3) {
        console.warn('[DaisoResizedImage] Invalid path structure:', cleanSrc)
        return cleanSrc
      }

      const [folder, date, ...filenameParts] = pathParts
      const filename = filenameParts.join('/')

      const url = `/file/resize/${folder}/${date}/${this.detail}/${this.size}/${filename}`

      // Lambda에서 처리
      // const params = new URLSearchParams()

      // if (this.quality) {
      //   params.append('quality', this.quality)
      // }

      // if (this.autorotate) {
      //   params.append('rotate', 'auto')
      // }

      // if (this.options.rotate && !this.autorotate) {
      //   params.append('rotate', this.options.rotate)
      // }

      // if (this.options.crop) {
      //   params.append('crop', this.options.crop)
      // }

      // if (this.options.format) {
      //   params.append('format', this.options.format)
      // }

      // const queryString = params.toString()
      // return queryString ? `${url}?${queryString}` : url

      return url
    },
    processedUrl (url) {
      if (!url) {
        this.$emit('error')
        return this.fallbackEnabled ? this.fallbackSrc : url
      }
      if (this.isErrorHandled || url.includes(this.noImagePath)) {
        this.$emit('error')
        return this.fallbackEnabled ? this.fallbackSrc : url
      }
      return url
    },
    load (event) {
      this.$emit('load', event)
    },
    errorImage (event) {
      if (!this.isErrorHandled) {
        this.isErrorHandled = true
        if (this.fallbackEnabled) {
          this.currentSrc = this.fallbackSrc
        }
        this.$emit('error', event)
      }
    }
  }
}
